var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25.5H0l6.196 8.26L.337 15.5h1.988l4.791-5.512L11.25 15.5h5.25l-6.456-8.608L15.6.5h-1.987l-4.49 5.164L5.25.5ZM12 14 3 2h1.5l9 12H12Z",
    fill: "#7F7B71"
  })));
};

export { SvgTwitter as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuMjUgMC41SDBMNi4xOTU2NSA4Ljc2MDg3TDAuMzM3NDYyIDE1LjQ5OTlIMi4zMjQ5OEw3LjExNjIzIDkuOTg4MjVMMTEuMjUgMTUuNUgxNi41TDEwLjA0MzggNi44OTE3MkwxNS42MDAxIDAuNUgxMy42MTI2TDkuMTIzMjIgNS42NjQzNEw1LjI1IDAuNVpNMTIgMTRMMyAySDQuNUwxMy41IDE0SDEyWiIgZmlsbD0iIzdGN0I3MSIvPgo8L3N2Zz4K";